// libs
import { useDispatch } from 'react-redux';

//actions
import { setSelectedSKUID, setSelectedSKUVendor } from 'shared/store/details/actions';

export const useSetSelectedSKU = () => {
  const dispatch = useDispatch();

  return (payload: { skuId: string; oneSize: boolean }) => dispatch(setSelectedSKUID(payload));
};

export const useSetSelectedSKUVendor = () => {
  const dispatch = useDispatch();

  return (payload: { vendorId: string; vendor: ProductDetail.IVendorDetails }) =>
    dispatch(setSelectedSKUVendor(payload));
};
